import type { MovieItem, NewsItem, VarietyItem } from "@/mocks/content";

export type AnyContent = NewsItem | MovieItem | VarietyItem;

export function contentLink(item: AnyContent): string {
  if (item.type === "news") return `/news/${item.id}`;
  if (item.type === "movie") return `/movies/${item.id}`;
  return `/variety/${item.id}`;
}

export function contentTypeName(item: AnyContent): string {
  if (item.type === "news") return item.newsType;
  if (item.type === "movie") return item.media;
  return item.genres[0] ?? "综艺";
}

export function contentMetaLine(item: AnyContent): string {
  if (item.type === "news") return `${item.source} · ${item.author}`;
  if (item.type === "movie") return `${item.year} · ${item.region} · ${item.genres.slice(0, 2).join(" / ")}`;
  return `${item.platform} · ${item.airTime}`;
}